'use strict';

angular.module('randomization')
    .controller('RandomizationController', ['AccountManager', function(AccountManager) {
        var vm = this;

        vm.hasPermission = AccountManager.hasPermission;
    }]);
